module.exports = __webpack_public_path__ + "ismv-static/media/mrestate-logo-one.95899e81.svg";